import React, { useEffect, createElement } from 'react';
import { Hero, TrustBar } from './components/Hero';
import { ShowerStyles, Comparison, DesignOptions } from './components/Products';
import { Quality, Checklist, Process, Benefits } from './components/Value';
import { Audiences, RelatedServices, WhyChoose, Locations } from './components/Company';
import { FAQ, FinalCTA, StickyMobileCTA } from './components/Conversion';
export function App() {
  useEffect(() => {
    // Update Document Title
    document.title = "Custom Glass Shower Doors & Enclosures Michigan | Kosin's Glass";
    // Update Meta Description
    const metaDesc = document.querySelector('meta[name="description"]');
    const descriptionContent = 'Custom glass shower doors, frameless enclosures and professional installation in Howell, Ann Arbor, Novi and Southeast Michigan. Request a free in-home quote.';
    if (metaDesc) {
      metaDesc.setAttribute('content', descriptionContent);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = descriptionContent;
      document.head.appendChild(meta);
    }
  }, []);
  return <main className="min-h-screen bg-white font-sans text-gray-800 pb-[76px] md:pb-0 selection:bg-primary/20 selection:text-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <ShowerStyles data-id="element-3" />
      <Comparison data-id="element-4" />
      <DesignOptions data-id="element-5" />
      <Quality data-id="element-6" />
      <Checklist data-id="element-7" />
      <Process data-id="element-8" />
      <Benefits data-id="element-9" />
      <Audiences data-id="element-10" />
      <RelatedServices data-id="element-11" />
      <WhyChoose data-id="element-12" />
      <Locations data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <StickyMobileCTA data-id="element-16" />
    </main>;
}